import { render } from "./AddLabels.vue?vue&type=template&id=55568a87"
import script from "./AddLabels.vue?vue&type=script&lang=js"
export * from "./AddLabels.vue?vue&type=script&lang=js"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__